import { render, staticRenderFns } from "./order-table-details-row.vue?vue&type=template&id=5355aeb5&scoped=true"
import script from "./order-table-details-row.vue?vue&type=script&lang=js"
export * from "./order-table-details-row.vue?vue&type=script&lang=js"
import style0 from "./order-table-details-row.vue?vue&type=style&index=0&id=5355aeb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355aeb5",
  null
  
)

export default component.exports